import React from "react";
import { Filter } from "lucide-react";
import { useProject } from "@/context/ProjectContext";

export function ProjectFilter() {
  const { project, setProject, projects } = useProject();
  if (projects.length === 0) return null;
  return (
    <div className="flex items-center gap-2">
      <Filter className="h-3.5 w-3.5 text-[#156F5B]" />
      <select
        value={project}
        onChange={(e) => setProject(e.target.value)}
        data-testid="project-filter-select"
        className="k-input !py-1.5 !px-2 !w-auto text-xs font-heading font-semibold"
      >
        <option value="">All projects</option>
        {projects.map((p) => (
          <option key={p.name} value={p.name}>
            {p.dis || p.name}
          </option>
        ))}
      </select>
    </div>
  );
}
